import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  readAdminCustomerRouteParam,
  readRouteParam,
} from '../../../_utils/route-param.utils';
import { TranslateModule } from '@ngx-translate/core';
import ITreatmentCategory from '../../../_interfaces/ITreatmentCategory';
import { AdminEntityLoaderService } from '../../../_services/admin/admin-entity-loader.service';
import { AdminFormLayoutComponent } from '../../../components/admin-ui/admin-form-layout/admin-form-layout.component';
import { AdminPageHeaderComponent } from '../../../components/admin-ui/admin-page-header/admin-page-header.component';
import { AdminStatePanelComponent } from '../../../components/admin-ui/admin-state-panel/admin-state-panel.component';
import { FormCategoryTreatmentsComponent } from '../../../components/forms/form-category-treatments/form-category-treatments.component';

@Component({
  selector: 'app-admin-treatment-category-detail',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    AdminPageHeaderComponent,
    AdminStatePanelComponent,
    AdminFormLayoutComponent,
    FormCategoryTreatmentsComponent,
  ],
  templateUrl: './admin-treatment-category-detail.component.html',
  styleUrl: './admin-treatment-category-detail.component.scss',
})
export class AdminTreatmentCategoryDetailComponent implements OnInit {
  public customersId = 0;
  public categoryId = 0;
  public category: ITreatmentCategory | null = null;
  public loading = true;
  public hasError = false;
  readonly reload = (): void => this.load();

  constructor(
    private readonly route: ActivatedRoute,
    private readonly loader: AdminEntityLoaderService,
  ) {}

  get backLink(): any[] {
    return [
      '/administration',
      readAdminCustomerRouteParam(this.route, this.customersId) || this.customersId,
      'treatments',
      'categories',
    ];
  }

  ngOnInit(): void {
    this.customersId = readRouteParam(this.route, 'customers_id');
    this.categoryId = readRouteParam(this.route, 'category_id');
    this.load(true);
  }

  load(fromResolver = false): void {
    this.loading = true;
    this.hasError = false;

    if (fromResolver) {
      const category = (this.route.snapshot.data['treatmentCategory'] || null) as
        | ITreatmentCategory
        | null;
      if (category) {
        this.category = category;
        this.loading = false;
        return;
      }
    }

    this.loader
      .loadTreatmentCategory(this.customersId, this.categoryId)
      .subscribe({
        next: (category) => {
          this.category = category;
          this.hasError = !category;
          this.loading = false;
        },
        error: () => {
          this.hasError = true;
          this.loading = false;
        },
      });
  }
}
